import { render, staticRenderFns } from "./PelatihanKomentar.vue?vue&type=template&id=eaa7f156"
import script from "./PelatihanKomentar.vue?vue&type=script&lang=js"
export * from "./PelatihanKomentar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports